import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const PhotosFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M6.98 12.26c-.4.02-.76.24-1.03.63l-3.82 5.54a2.646 2.646 0 0 0 2.52 1.88h9.67l-6.31-7.55c-.28-.34-.64-.52-1.03-.5Z" />
      <Path d="M16.47 6.6H4.65C3.19 6.6 2 7.79 2 9.25v7.35l3-4.35c.47-.68 1.17-1.09 1.92-1.13.73-.05 1.46.3 1.97.91l2.73 3.27 1.94-1.87c.39-.38.93-.57 1.48-.55.55.03 1.07.29 1.41.7l2.68 3.22V9.24c0-1.46-1.19-2.65-2.65-2.65l-.01.01Zm-.94 4.4a1.071 1.071 0 0 1 0-2.14 1.071 1.071 0 0 1 0 2.14Z" />
      <Path d="M14.97 14.03c-.19 0-.38.06-.53.2l-2.05 1.98 3.43 4.11h.65c1.17 0 2.15-.77 2.5-1.82l-3.49-4.21a.712.712 0 0 0-.52-.26h.01ZM18.81 4.02H7.6c-1.15 0-2.14.68-2.6 1.65h13.2c.9 0 1.63.73 1.63 1.63v9.32c0 .11-.01.21-.03.31 1.11-.41 1.9-1.46 1.9-2.71V6.91c0-1.6-1.3-2.89-2.89-2.89Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default PhotosFilled
